webpackJsonp([2,0],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(120);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	__webpack_require__(195);
	
	var _vueRouter = __webpack_require__(480);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _App = __webpack_require__(464);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _store = __webpack_require__(183);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _index = __webpack_require__(467);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _txt = __webpack_require__(180);
	
	var _txt2 = _interopRequireDefault(_txt);
	
	var _collection = __webpack_require__(465);
	
	var _collection2 = _interopRequireDefault(_collection);
	
	var _single = __webpack_require__(469);
	
	var _single2 = _interopRequireDefault(_single);
	
	var _home = __webpack_require__(466);
	
	var _home2 = _interopRequireDefault(_home);
	
	var _search = __webpack_require__(468);
	
	var _search2 = _interopRequireDefault(_search);
	
	var _vueWaypoint = __webpack_require__(481);
	
	var _vueWaypoint2 = _interopRequireDefault(_vueWaypoint);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueRouter2.default);
	_vue2.default.use(_vueWaypoint2.default);
	
	var router = new _vueRouter2.default({
	  mode: 'history',
	  routes: [{
	    path: '/',
	    name: 'home',
	    component: _home2.default
	  }, {
	    path: '/item/:id/:slug',
	    name: 'single',
	    component: _single2.default
	  }, {
	    path: '/collection/:id/:slug',
	    name: 'collection',
	    component: _collection2.default
	  }, {
	    path: '/search/:term',
	    name: 'search',
	    component: _search2.default
	  }, {
	    path: '/index',
	    name: 'index',
	    component: _index2.default
	  }, {
	    path: '/text/:id',
	    name: 'text',
	    component: _txt2.default
	  }],
	  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
	    if (savedPosition) {
	      return savedPosition;
	    } else {
	      return { x: 0, y: 0 };
	    }
	  }
	});
	
	new _vue2.default({
	  el: '#app',
	  store: _store2.default,
	  router: router,
	  render: function render(h) {
	    return h(_App2.default);
	  }
	});

/***/ }),

/***/ 119:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(442)
	
	var Component = __webpack_require__(35)(
	  /* script */
	  __webpack_require__(191),
	  /* template */
	  __webpack_require__(471),
	  /* scopeId */
	  "data-v-0e2e5b9d",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 179:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(447)
	
	var Component = __webpack_require__(35)(
	  /* script */
	  __webpack_require__(187),
	  /* template */
	  __webpack_require__(476),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 180:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(446)
	
	var Component = __webpack_require__(35)(
	  /* script */
	  __webpack_require__(194),
	  /* template */
	  __webpack_require__(475),
	  /* scopeId */
	  "data-v-6eed1756",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 181:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(121);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _vue = __webpack_require__(120);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueResource = __webpack_require__(479);
	
	var _vueResource2 = _interopRequireDefault(_vueResource);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var API_ROOT = 'https://api.jacquesdaniel.benediktreichenbach.com/wp-json/wp/v2/';
	var INDEX_ID = 12;
	
	_vue2.default.use(_vueResource2.default);
	
	_vue2.default.http.options.crossOrigin = true;
	
	exports.default = {
	  getItems: function getItems(offset) {
	    return new _promise2.default(function (resolve, reject) {
	      _vue2.default.http.get(API_ROOT + 'item?per_page=10&page=' + offset).then(function (response) {
	        resolve(response);
	      }, function (response) {
	        reject();
	      });
	    });
	  },
	  getAllTexts: function getAllTexts() {
	    return new _promise2.default(function (resolve, reject) {
	      _vue2.default.http.get(API_ROOT + 'text?per_page=100').then(function (response) {
	        resolve(response.body);
	      }, function (response) {
	        reject();
	      });
	    });
	  },
	  getSingle: function getSingle(id) {
	    return new _promise2.default(function (resolve, reject) {
	      _vue2.default.http.get(API_ROOT + 'item/' + id).then(function (response) {
	        resolve(response.body);
	      }, function (response) {
	        reject();
	      });
	    });
	  },
	  getCollection: function getCollection(id) {
	    return new _promise2.default(function (resolve, reject) {
	      _vue2.default.http.get(API_ROOT + 'item/?per_page=100&collection=' + id).then(function (response) {
	        resolve({
	          id: id,
	          posts: response.body
	        });
	      }, function (response) {
	        reject();
	      });
	    });
	  },
	  getAllCollections: function getAllCollections() {
	    return new _promise2.default(function (resolve, reject) {
	      _vue2.default.http.get(API_ROOT + 'collection').then(function (response) {
	        resolve(response.body);
	      }, function (response) {
	        reject();
	      });
	    });
	  },
	  getText: function getText(id) {
	    return new _promise2.default(function (resolve, reject) {
	      _vue2.default.http.get(API_ROOT + 'text/' + id).then(function (response) {
	        resolve(response.body);
	      }, function (response) {
	        reject();
	      });
	    });
	  },
	  getIndex: function getIndex() {
	    return new _promise2.default(function (resolve, reject) {
	      _vue2.default.http.get(API_ROOT + 'pages/' + INDEX_ID).then(function (response) {
	        resolve(response.body);
	      }, function (response) {
	        reject();
	      });
	    });
	  },
	  getSearch: function getSearch(term) {
	    return new _promise2.default(function (resolve, reject) {
	      _vue2.default.http.get(API_ROOT + 'item/?search=' + encodeURI(term) + '&per_page=100').then(function (response) {
	        resolve({ posts: response.body, term: term });
	      }, function (response) {
	        reject();
	      });
	    });
	  }
	};

/***/ }),

/***/ 182:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var GET_ITEMS = exports.GET_ITEMS = 'GET_ITEMS';
	var GET_COLLECTIONS = exports.GET_COLLECTIONS = 'GET_COLLECTIONS';
	var GET_ALL_TEXTS = exports.GET_ALL_TEXTS = 'GET_ALL_TEXTS';
	var GET_SINGLE = exports.GET_SINGLE = 'GET_SINGLE';
	var CHANGE_SINGLE = exports.CHANGE_SINGLE = 'CHANGE_SINGLE';
	var GET_INDEX = exports.GET_INDEX = 'GET_INDEX';
	var GET_COLLECTION = exports.GET_COLLECTION = 'GET_COLLECTION';
	var GET_SEARCH = exports.GET_SEARCH = 'GET_SEARCH';
	var SET_CONTEXT = exports.SET_CONTEXT = 'SET_CONTEXT';
	var SET_N = exports.SET_N = 'SET_N';
	var SET_BUSY = exports.SET_BUSY = 'SET_BUSY';
	var SET_FILTER = exports.SET_FILTER = 'SET_FILTER';
	var RESET_SINGLE_ITEM = exports.RESET_SINGLE_ITEM = 'RESET_SINGLE_ITEM';
	var RESET_COLLECTION = exports.RESET_COLLECTION = 'RESET_COLLECTION';
	var RESET_SEARCH = exports.RESET_SEARCH = 'RESET_SEARCH';
	var HIDE_TEXT = exports.HIDE_TEXT = 'HIDE_TEXT';
	var SHOW_TEXT = exports.SHOW_TEXT = 'SHOW_TEXT';
	var SHOW_SHARE = exports.SHOW_SHARE = 'SHOW_SHARE';
	var HIDE_SHARE = exports.HIDE_SHARE = 'HIDE_SHARE';
	var SET_COLLECTION_ENTRY = exports.SET_COLLECTION_ENTRY = 'SET_COLLECTION_ENTRY';

/***/ }),

/***/ 183:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(120);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(30);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	var _main = __webpack_require__(184);
	
	var _main2 = _interopRequireDefault(_main);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vuex2.default);
	
	var DEBUG = ("production") === 'development';
	
	exports.default = new _vuex2.default.Store({
	  modules: {
	    main: _main2.default
	  },
	  strict: DEBUG
	});

/***/ }),

/***/ 184:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(199);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _regenerator = __webpack_require__(202);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(198);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _actions, _mutations;
	
	var _wp = __webpack_require__(181);
	
	var _wp2 = _interopRequireDefault(_wp);
	
	var _actionTypes = __webpack_require__(182);
	
	var actionTypes = _interopRequireWildcard(_actionTypes);
	
	var _mutationTypes = __webpack_require__(185);
	
	var mutationTypes = _interopRequireWildcard(_mutationTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = {
	  items: [],
	  text: {},
	  texts: [],
	  collection: {},
	  collections: [],
	  index: {},
	  search: {},
	  filter: 0,
	  busy: false,
	  searchTerm: '',
	  horizontal: {
	    parent: '',
	    context: {},
	    index: 0
	  },
	  loaded: {
	    items: false,
	    collection: false,
	    single: false,
	    text: false,
	    texts: false,
	    index: false,
	    search: false,
	    share: false
	  },
	  offset: 1,
	  collectionEntry: 0
	};
	
	var actions = (_actions = {}, (0, _defineProperty3.default)(_actions, actionTypes.GET_ITEMS, function (_ref) {
	  var _this = this;
	
	  var commit = _ref.commit,
	      state = _ref.state;
	  return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            _context.t0 = commit;
	            _context.t1 = mutationTypes.SET_ITEMS;
	            _context.next = 4;
	            return _wp2.default.getItems(state.offset);
	
	          case 4:
	            _context.t2 = _context.sent;
	            (0, _context.t0)(_context.t1, _context.t2);
	
	          case 6:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, _this);
	  }))();
	}), (0, _defineProperty3.default)(_actions, actionTypes.GET_SINGLE, function (_ref2, id) {
	  var _this2 = this;
	
	  var commit = _ref2.commit,
	      state = _ref2.state;
	  return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
	    return _regenerator2.default.wrap(function _callee2$(_context2) {
	      while (1) {
	        switch (_context2.prev = _context2.next) {
	          case 0:
	            _context2.t0 = commit;
	            _context2.t1 = mutationTypes.SET_SINGLE;
	            _context2.next = 4;
	            return _wp2.default.getSingle(id);
	
	          case 4:
	            _context2.t2 = _context2.sent;
	            (0, _context2.t0)(_context2.t1, _context2.t2);
	
	          case 6:
	          case 'end':
	            return _context2.stop();
	        }
	      }
	    }, _callee2, _this2);
	  }))();
	}), (0, _defineProperty3.default)(_actions, actionTypes.GET_ALL_TEXTS, function (_ref3, id) {
	  var _this3 = this;
	
	  var commit = _ref3.commit,
	      state = _ref3.state;
	  return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
	    return _regenerator2.default.wrap(function _callee3$(_context3) {
	      while (1) {
	        switch (_context3.prev = _context3.next) {
	          case 0:
	            _context3.t0 = commit;
	            _context3.t1 = mutationTypes.SET_ALL_TEXTS;
	            _context3.next = 4;
	            return _wp2.default.getAllTexts();
	
	          case 4:
	            _context3.t2 = _context3.sent;
	            (0, _context3.t0)(_context3.t1, _context3.t2);
	
	          case 6:
	          case 'end':
	            return _context3.stop();
	        }
	      }
	    }, _callee3, _this3);
	  }))();
	}), (0, _defineProperty3.default)(_actions, actionTypes.CHANGE_SINGLE, function (_ref4, newItem) {
	  var commit = _ref4.commit,
	      state = _ref4.state;
	
	  commit(mutationTypes.SET_SINGLE, newItem);
	}), (0, _defineProperty3.default)(_actions, actionTypes.GET_INDEX, function (_ref5) {
	  var _this4 = this;
	
	  var commit = _ref5.commit,
	      state = _ref5.state;
	  return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4() {
	    return _regenerator2.default.wrap(function _callee4$(_context4) {
	      while (1) {
	        switch (_context4.prev = _context4.next) {
	          case 0:
	            _context4.t0 = commit;
	            _context4.t1 = mutationTypes.SET_INDEX;
	            _context4.next = 4;
	            return _wp2.default.getIndex();
	
	          case 4:
	            _context4.t2 = _context4.sent;
	            (0, _context4.t0)(_context4.t1, _context4.t2);
	
	          case 6:
	          case 'end':
	            return _context4.stop();
	        }
	      }
	    }, _callee4, _this4);
	  }))();
	}), (0, _defineProperty3.default)(_actions, actionTypes.GET_COLLECTION, function (_ref6, id) {
	  var _this5 = this;
	
	  var commit = _ref6.commit,
	      state = _ref6.state;
	  return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee5() {
	    return _regenerator2.default.wrap(function _callee5$(_context5) {
	      while (1) {
	        switch (_context5.prev = _context5.next) {
	          case 0:
	            _context5.t0 = commit;
	            _context5.t1 = mutationTypes.SET_COLLECTION;
	            _context5.next = 4;
	            return _wp2.default.getCollection(id);
	
	          case 4:
	            _context5.t2 = _context5.sent;
	            (0, _context5.t0)(_context5.t1, _context5.t2);
	
	          case 6:
	          case 'end':
	            return _context5.stop();
	        }
	      }
	    }, _callee5, _this5);
	  }))();
	}), (0, _defineProperty3.default)(_actions, actionTypes.GET_COLLECTIONS, function (_ref7) {
	  var _this6 = this;
	
	  var commit = _ref7.commit,
	      state = _ref7.state;
	  return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee6() {
	    return _regenerator2.default.wrap(function _callee6$(_context6) {
	      while (1) {
	        switch (_context6.prev = _context6.next) {
	          case 0:
	            _context6.t0 = commit;
	            _context6.t1 = mutationTypes.SET_COLLECTIONS;
	            _context6.next = 4;
	            return _wp2.default.getAllCollections();
	
	          case 4:
	            _context6.t2 = _context6.sent;
	            (0, _context6.t0)(_context6.t1, _context6.t2);
	
	          case 6:
	          case 'end':
	            return _context6.stop();
	        }
	      }
	    }, _callee6, _this6);
	  }))();
	}), (0, _defineProperty3.default)(_actions, actionTypes.GET_SEARCH, function (_ref8, term) {
	  var _this7 = this;
	
	  var commit = _ref8.commit,
	      state = _ref8.state;
	  return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee7() {
	    return _regenerator2.default.wrap(function _callee7$(_context7) {
	      while (1) {
	        switch (_context7.prev = _context7.next) {
	          case 0:
	            _context7.t0 = commit;
	            _context7.t1 = mutationTypes.SET_SEARCH;
	            _context7.next = 4;
	            return _wp2.default.getSearch(term);
	
	          case 4:
	            _context7.t2 = _context7.sent;
	            (0, _context7.t0)(_context7.t1, _context7.t2);
	
	          case 6:
	          case 'end':
	            return _context7.stop();
	        }
	      }
	    }, _callee7, _this7);
	  }))();
	}), (0, _defineProperty3.default)(_actions, actionTypes.RESET_SINGLE_ITEM, function (_ref9) {
	  var commit = _ref9.commit,
	      state = _ref9.state;
	
	  commit(mutationTypes.RESET_SINGLE_ITEM);
	}), (0, _defineProperty3.default)(_actions, actionTypes.RESET_COLLECTION, function (_ref10) {
	  var commit = _ref10.commit,
	      state = _ref10.state;
	
	  commit(mutationTypes.RESET_COLLECTION);
	}), (0, _defineProperty3.default)(_actions, actionTypes.RESET_SEARCH, function (_ref11) {
	  var commit = _ref11.commit,
	      state = _ref11.state;
	
	  commit(mutationTypes.RESET_SEARCH);
	}), (0, _defineProperty3.default)(_actions, actionTypes.HIDE_TEXT, function (_ref12) {
	  var commit = _ref12.commit,
	      state = _ref12.state;
	
	  commit(mutationTypes.HIDE_TEXT);
	}), (0, _defineProperty3.default)(_actions, actionTypes.SHOW_TEXT, function (_ref13, id) {
	  var commit = _ref13.commit,
	      state = _ref13.state;
	
	  var newText = state.texts.find(function (text) {
	    return Number(text.id) === Number(id);
	  });
	  if (newText) {
	    commit(mutationTypes.SHOW_TEXT, newText);
	  }
	}), (0, _defineProperty3.default)(_actions, actionTypes.SET_CONTEXT, function (_ref14, arg) {
	  var commit = _ref14.commit,
	      state = _ref14.state;
	
	  commit(mutationTypes.SET_CONTEXT, arg);
	}), (0, _defineProperty3.default)(_actions, actionTypes.SET_N, function (_ref15, data) {
	  var commit = _ref15.commit,
	      state = _ref15.state;
	
	  commit(mutationTypes.SET_N, data);
	}), (0, _defineProperty3.default)(_actions, actionTypes.SET_BUSY, function (_ref16) {
	  var commit = _ref16.commit,
	      state = _ref16.state;
	
	  commit(mutationTypes.SET_BUSY);
	}), (0, _defineProperty3.default)(_actions, actionTypes.SET_FILTER, function (_ref17, id) {
	  var commit = _ref17.commit,
	      state = _ref17.state;
	
	  commit(mutationTypes.SET_FILTER, id);
	}), (0, _defineProperty3.default)(_actions, actionTypes.HIDE_SHARE, function (_ref18) {
	  var commit = _ref18.commit,
	      state = _ref18.state;
	
	  commit(mutationTypes.HIDE_SHARE);
	}), (0, _defineProperty3.default)(_actions, actionTypes.SHOW_SHARE, function (_ref19) {
	  var commit = _ref19.commit,
	      state = _ref19.state;
	
	  commit(mutationTypes.SHOW_SHARE);
	}), (0, _defineProperty3.default)(_actions, actionTypes.SET_COLLECTION_ENTRY, function (_ref20, data) {
	  var commit = _ref20.commit,
	      state = _ref20.state;
	
	  commit(mutationTypes.SET_COLLECTION_ENTRY, data);
	}), _actions);
	
	var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, mutationTypes.SET_ITEMS, function (state, data) {
	  state.items.push.apply(state.items, data.body);
	  state.loaded.items = true;
	
	  if (data.headers.map['x-wp-totalpages']) {
	    state.pages = data.headers.map['x-wp-totalpages'][0];
	  } else {
	    state.pages = data.headers.map['X-WP-TotalPages'][0];
	  }
	  state.offset = state.offset + 1;
	}), (0, _defineProperty3.default)(_mutations, mutationTypes.SET_ALL_TEXTS, function (state, data) {
	  state.texts.push.apply(state.texts, data);
	  state.loaded.texts = true;
	}), (0, _defineProperty3.default)(_mutations, mutationTypes.SET_SINGLE, function (state, data) {
	  state.single = data;
	  state.loaded.single = true;
	}), (0, _defineProperty3.default)(_mutations, mutationTypes.SET_COLLECTIONS, function (state, data) {
	  state.collections = data;
	}), (0, _defineProperty3.default)(_mutations, mutationTypes.SET_INDEX, function (state, data) {
	  state.index = data;
	  state.loaded.index = true;
	}), (0, _defineProperty3.default)(_mutations, mutationTypes.SET_COLLECTION, function (state, data) {
	  state.collectionId = data.id;
	  state.collection = data.posts;
	  state.loaded.collection = true;
	}), (0, _defineProperty3.default)(_mutations, mutationTypes.SET_SEARCH, function (state, data) {
	  state.search = data.posts;
	  state.searchTerm = data.term;
	  state.loaded.search = true;
	}), (0, _defineProperty3.default)(_mutations, mutationTypes.RESET_SINGLE_ITEM, function (state) {
	  state.single = {};
	  state.loaded.single = false;
	}), (0, _defineProperty3.default)(_mutations, mutationTypes.RESET_COLLECTION, function (state) {
	  state.collection = {};
	  state.loaded.collection = false;
	}), (0, _defineProperty3.default)(_mutations, mutationTypes.RESET_SEARCH, function (state) {
	  state.search = {};
	  state.searchTerm = '';
	  state.loaded.search = false;
	}), (0, _defineProperty3.default)(_mutations, mutationTypes.HIDE_TEXT, function (state) {
	  state.text = {};
	  state.loaded.text = false;
	}), (0, _defineProperty3.default)(_mutations, mutationTypes.SHOW_TEXT, function (state, data) {
	  state.text = data;
	  state.loaded.text = true;
	}), (0, _defineProperty3.default)(_mutations, mutationTypes.SET_CONTEXT, function (state, arg) {
	  state.horizontal.context = arg.data;
	  state.horizontal.parent = arg.parent;
	}), (0, _defineProperty3.default)(_mutations, mutationTypes.SET_N, function (state, data) {
	  state.horizontal.index = data;
	}), (0, _defineProperty3.default)(_mutations, mutationTypes.SET_BUSY, function (state) {
	  state.busy = true;
	}), (0, _defineProperty3.default)(_mutations, mutationTypes.HIDE_SHARE, function (state) {
	  state.loaded.share = false;
	}), (0, _defineProperty3.default)(_mutations, mutationTypes.SHOW_SHARE, function (state) {
	  state.loaded.share = true;
	}), (0, _defineProperty3.default)(_mutations, mutationTypes.SET_COLLECTION_ENTRY, function (state, data) {
	  state.collectionEntry = data;
	}), (0, _defineProperty3.default)(_mutations, mutationTypes.SET_FILTER, function (state, id) {
	  state.filter = id;
	}), _mutations);
	
	exports.default = {
	  state: state,
	  actions: actions,
	  mutations: mutations
	};

/***/ }),

/***/ 185:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var SET_ITEMS = exports.SET_ITEMS = 'SET_ITEMS';
	var SET_COLLECTIONS = exports.SET_COLLECTIONS = 'SET_COLLECTIONS';
	var SET_ALL_TEXTS = exports.SET_ALL_TEXTS = 'SET_ALL_TEXTS';
	var SET_SINGLE = exports.SET_SINGLE = 'SET_SINGLE';
	var SET_INDEX = exports.SET_INDEX = 'SET_INDEX';
	var SET_COLLECTION = exports.SET_COLLECTION = 'SET_COLLECTION';
	var SET_SEARCH = exports.SET_SEARCH = 'SET_SEARCH';
	var SET_TERM = exports.SET_TERM = 'SET_TERM';
	var SET_CONTEXT = exports.SET_CONTEXT = 'SET_CONTEXT';
	var SET_N = exports.SET_N = 'SET_N';
	var SET_BUSY = exports.SET_BUSY = 'SET_BUSY';
	var RESET_SINGLE_ITEM = exports.RESET_SINGLE_ITEM = 'RESET_SINGLE_ITEM';
	var RESET_COLLECTION = exports.RESET_COLLECTION = 'RESET_COLLECTION';
	var RESET_SEARCH = exports.RESET_SEARCH = 'RESET_SEARCH';
	var HIDE_TEXT = exports.HIDE_TEXT = 'HIDE_TEXT';
	var SHOW_TEXT = exports.SHOW_TEXT = 'SHOW_TEXT';
	var SHOW_SHARE = exports.SHOW_SHARE = 'SHOW_SHARE';
	var HIDE_SHARE = exports.HIDE_SHARE = 'HIDE_SHARE';
	var SET_COLLECTION_ENTRY = exports.SET_COLLECTION_ENTRY = 'SET_COLLECTION_ENTRY';
	var SET_FILTER = exports.SET_FILTER = 'SET_FILTER';

/***/ }),

/***/ 186:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(31);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(30);
	
	var _cap = __webpack_require__(179);
	
	var _cap2 = _interopRequireDefault(_cap);
	
	var _txt = __webpack_require__(180);
	
	var _txt2 = _interopRequireDefault(_txt);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'app',
	  components: {
	    cap: _cap2.default,
	    txt: _txt2.default
	  },
	  data: function data() {
	    return {
	      searchTerm: '',
	      filter: {
	        extended: false,
	        id: 0
	      },
	      timeNow: {},
	      timeFormat: '',
	      dateFormat: '',
	      scrollY: 0,
	      isInsideCollection: false,
	      cachedSingleId: -1
	    };
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapState)(['main'])),
	  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['GET_ITEMS', 'GET_INDEX', 'GET_COLLECTIONS', 'GET_ALL_TEXTS', 'SHOW_TEXT', 'SET_FILTER', 'RESET_SINGLE_ITEM', 'SET_CONTEXT', 'RESET_COLLECTION', 'RESET_SEARCH', 'HIDE_TEXT', 'HIDE_SHARE']), {
	    submitSearch: function submitSearch() {
	      this.$router.push({ name: 'search', params: { term: this.searchTerm } });
	    },
	    scrollToItem: function scrollToItem(id) {
	      var _this = this;
	
	      setTimeout(function () {
	        if (id && document.getElementById('item-' + id) != null) {
	          window.scrollTo(0, document.getElementById('item-' + id).offsetTop - 40);
	        } else {
	          window.scrollTo(0, _this.scrollY);
	        }
	      }, 250);
	    },
	    toHome: function toHome() {
	      if (this.$route.name === 'home') {
	        window.scrollTo(0, 0);
	      } else {
	        this.RESET_SINGLE_ITEM();
	        this.$router.push({ name: 'home' });
	      }
	    },
	    toggleFilter: function toggleFilter(e) {
	      this.SET_FILTER(0);
	      this.filter.extended = !this.filter.extended;
	    }
	  }),
	  mounted: function mounted() {
	    var _this2 = this;
	
	    this.GET_ITEMS();
	    this.GET_INDEX();
	    this.GET_ALL_TEXTS();
	    this.$router.beforeEach(function (to, from, next) {
	      if (from.name === 'single' && to.name === 'single' && !_this2.isInsideCollection) {
	        _this2.cachedSingleId = to.params.id;
	      }
	
	      if (from.name === 'search' && to.name === 'single') {
	        _this2.scrollY = (window.pageYOffset || document.documentElement.scrollTop) - (document.documentElement.clientTop || 0);
	        _this2.SET_CONTEXT({
	          data: _this2.main.search.filter(function (item) {
	            return item.acf.Image_display !== 'None';
	          }),
	          parent: 'search'
	        });
	      }
	      if (from.name === 'collection' && to.name === 'single') {
	        _this2.isInsideCollection = true;
	        _this2.SET_CONTEXT({
	          data: _this2.main.collection.filter(function (item) {
	            return item.acf.Image_display !== 'None';
	          }),
	          parent: 'collection'
	        });
	      }
	      if (from.name === 'home' && to.name === 'single') {
	        _this2.scrollY = (window.pageYOffset || document.documentElement.scrollTop) - (document.documentElement.clientTop || 0);
	        _this2.SET_CONTEXT({
	          data: _this2.main.items.filter(function (item) {
	            return item.acf.show_in_front_page_mosaic && item.acf.Image_display !== 'None';
	          }),
	          parent: 'home'
	        });
	      }
	      if (from.name === 'search' && to.name !== 'single') {
	        _this2.searchTerm = '';
	        _this2.RESET_SEARCH();
	      }
	      if (to.name === 'home' || to.name === 'search' || to.name === 'index') {
	        _this2.RESET_COLLECTION();
	      }
	      if (from.name === 'single' && (to.name === 'home' || to.name === 'collection' || to.name === 'search')) {
	        _this2.scrollToItem(_this2.main.single.id);
	      }
	      if (from.name === 'collection' && to.name === 'home') {
	        _this2.isInsideCollection = false;
	        if (_this2.main.collectionEntry) {
	          _this2.scrollToItem(_this2.main.collectionEntry);
	        } else {
	          _this2.scrollToItem(_this2.cachedSingleId);
	        }
	      }
	      if (from.name === 'single') {
	        _this2.RESET_SINGLE_ITEM();
	      }
	      _this2.HIDE_TEXT();
	
	      next();
	    });
	  },
	
	  watch: {
	    'main.offset': function mainOffset() {
	      if (this.main.offset <= this.main.pages) {
	        this.GET_ITEMS();
	      }
	    }
	  }
	};

/***/ }),

/***/ 187:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(31);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'cap',
	  props: ['content', 'links', 'id'],
	  computed: (0, _extends3.default)({}, (0, _vuex.mapState)(['main']), {
	    noSpaceContent: function noSpaceContent() {
	      return this.content.replace(/&nbsp;/g, '<div class="divider"></div>');
	    }
	  }),
	  methods: (0, _extends3.default)({
	    closestByClass: function closestByClass(el, clazz) {
	      while (el.className !== clazz) {
	        el = el.parentNode;
	        if (!el) {
	          return null;
	        }
	      }
	      return el;
	    }
	  }, (0, _vuex.mapActions)(['SHOW_TEXT', 'SET_COLLECTION_ENTRY'])),
	  mounted: function mounted() {
	    var _this = this;
	
	    var collectionLinks = this.$el.querySelectorAll('.collection-link');
	
	    var _loop = function _loop(i) {
	      collectionLinks[i].addEventListener('click', function () {
	        _this.SET_COLLECTION_ENTRY(_this.id);
	        _this.$router.push({
	          name: 'collection',
	          params: {
	            id: collectionLinks[i].dataset.id,
	            slug: collectionLinks[i].dataset.href
	          }
	        });
	      });
	    };
	
	    for (var i = 0; i < collectionLinks.length; i++) {
	      _loop(i);
	    }
	
	    var textLinks = this.$el.querySelectorAll('.text-link');
	
	    var _loop2 = function _loop2(i) {
	      textLinks[i].addEventListener('click', function () {
	        var parent = _this.closestByClass(_this.$el, 'item');
	        if (parent) {
	          parent.classList.add('active-item');
	          document.body.classList.add('no-scroll');
	        }
	        _this.SHOW_TEXT(textLinks[i].dataset.id);
	      });
	    };
	
	    for (var i = 0; i < textLinks.length; i++) {
	      _loop2(i);
	    }
	  }
	};

/***/ }),

/***/ 188:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(31);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(30);
	
	var _item = __webpack_require__(119);
	
	var _item2 = _interopRequireDefault(_item);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'collection',
	  components: {
	    item: _item2.default
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapState)(['main'])),
	  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['GET_COLLECTION']), {
	    exit: function exit() {
	      this.$router.push({ name: 'index' });
	    }
	  }),
	  mounted: function mounted() {
	    if (this.$route.params.id) {
	      this.GET_COLLECTION(this.$route.params.id);
	    }
	  },
	
	  watch: {
	    $route: function $route() {
	      if (this.$route.params.id) {
	        this.GET_COLLECTION(this.$route.params.id);
	      }
	    }
	  }
	};

/***/ }),

/***/ 189:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(31);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(30);
	
	var _item = __webpack_require__(119);
	
	var _item2 = _interopRequireDefault(_item);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'home',
	  components: {
	    item: _item2.default
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapState)(['main'])),
	  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['GET_INDEX', 'SHOW_TEXT']), {
	    rigTextLinks: function rigTextLinks() {
	      var _this = this;
	
	      var textLinks = document.querySelectorAll('.text-link');
	
	      var _loop = function _loop(i) {
	        textLinks[i].addEventListener('click', function () {
	          _this.SHOW_TEXT(textLinks[i].dataset.id);
	        });
	      };
	
	      for (var i = 0; i < textLinks.length; i++) {
	        _loop(i);
	      }
	    }
	  }),
	  mounted: function mounted() {
	    if (!this.main.loaded.index) {
	      this.GET_INDEX();
	    } else {
	      this.rigTextLinks();
	    }
	  }
	};

/***/ }),

/***/ 190:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(31);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'index',
	  computed: (0, _extends3.default)({}, (0, _vuex.mapState)(['main'])),
	  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['GET_INDEX', 'SHOW_TEXT']), {
	    rigTextLinks: function rigTextLinks() {
	      var _this = this;
	
	      var textLinks = document.querySelectorAll('.text-link');
	
	      var _loop = function _loop(i) {
	        textLinks[i].addEventListener('click', function () {
	          _this.SHOW_TEXT(textLinks[i].dataset.id);
	        });
	      };
	
	      for (var i = 0; i < textLinks.length; i++) {
	        _loop(i);
	      }
	    }
	  }),
	  mounted: function mounted() {
	    if (!this.main.loaded.index) {
	      this.GET_INDEX();
	    } else {
	      this.rigTextLinks();
	    }
	  },
	
	  watch: {
	    'main.loaded.index': function mainLoadedIndex() {
	      this.rigTextLinks();
	    }
	  }
	};

/***/ }),

/***/ 191:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(31);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _cap = __webpack_require__(179);
	
	var _cap2 = _interopRequireDefault(_cap);
	
	var _vuex = __webpack_require__(30);
	
	var _preloader = __webpack_require__(173);
	
	var _preloader2 = _interopRequireDefault(_preloader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'item',
	  components: {
	    cap: _cap2.default
	  },
	  data: function data() {
	    return {
	      captionShown: false,
	      loaded: false
	    };
	  },
	
	  props: ['item', 'index', 'mosaic'],
	  computed: (0, _extends3.default)({}, (0, _vuex.mapState)(['main']), {
	    imageClass: function imageClass() {
	      if (this.item.acf.image_orienation === 'Vertical') {
	        return 'vertical';
	      } else {
	        return 'horizontal';
	      }
	    }
	  }),
	  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['SET_N']), {
	    openSingle: function openSingle() {
	      this.SET_N(this.index);
	      this.$router.push({
	        name: 'single',
	        params: { id: this.item.id, slug: this.item.slug }
	      });
	    },
	    inHandler: function inHandler() {
	      if (!this.loaded) {
	        if (this.item.acf.full_size_image) {
	          var loader = (0, _preloader2.default)({
	            xhrImages: false
	          });
	          loader.add(this.item.acf.full_size_image.sizes['pwr-large']);
	          loader.load();
	        }
	        this.loaded = true;
	      }
	    }
	  })
	};

/***/ }),

/***/ 192:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(31);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(30);
	
	var _item = __webpack_require__(119);
	
	var _item2 = _interopRequireDefault(_item);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'search',
	  components: {
	    item: _item2.default
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapState)(['main'])),
	  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['GET_SEARCH']), {
	    exit: function exit() {
	      this.$router.push({ name: 'home' });
	    }
	  }),
	  mounted: function mounted() {
	    if (this.$route.params.term) {
	      this.GET_SEARCH(this.$route.params.term);
	    }
	  }
	};

/***/ }),

/***/ 193:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(31);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(30);
	
	var _objectFitImages = __webpack_require__(451);
	
	var _objectFitImages2 = _interopRequireDefault(_objectFitImages);
	
	var _noframe = __webpack_require__(460);
	
	var _noframe2 = _interopRequireDefault(_noframe);
	
	var _preloader = __webpack_require__(173);
	
	var _preloader2 = _interopRequireDefault(_preloader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'single',
	  computed: (0, _extends3.default)({}, (0, _vuex.mapState)(['main'])),
	  data: function data() {
	    return {
	      title: '',
	      mainImage: '',
	      nextIndex: 0,
	      prevIndex: 0,
	      collectionLength: 0
	    };
	  },
	
	  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['RESET_SINGLE_ITEM', 'CHANGE_SINGLE', 'GET_SINGLE', 'SET_N']), {
	    updateItem: function updateItem() {
	      this.RESET_SINGLE_ITEM();
	      var id = this.$route.params.id;
	      if (id) {
	        var newItem = this.main.items.find(function (item) {
	          return item.id === id;
	        });
	        if (newItem) {
	          this.CHANGE_SINGLE(newItem);
	        } else {
	          this.GET_SINGLE(id);
	        }
	      }
	    },
	    nextItem: function nextItem() {
	      this.mainImage = '';
	      this.$router.push({ name: 'single', params: { id: this.main.horizontal.context[this.nextIndex].id, slug: this.main.horizontal.context[this.nextIndex].slug } });
	    },
	    prevItem: function prevItem() {
	      this.mainImage = '';
	      this.$router.push({ name: 'single', params: { id: this.main.horizontal.context[this.prevIndex].id, slug: this.main.horizontal.context[this.prevIndex].slug } });
	    },
	    exit: function exit() {
	      if (this.main.horizontal.parent === 'search') {
	        this.$router.push({ name: 'search', params: { term: this.main.searchTerm } });
	      } else if (this.main.horizontal.parent === 'collection') {
	        this.$router.push({ name: 'collection', params: { id: this.main.collectionId } });
	      } else {
	        this.$router.push({ name: 'home' });
	      }
	    }
	  }),
	  mounted: function mounted() {
	    this.collectionLength = this.main.horizontal.context.length;
	    this.updateItem();
	  },
	
	  watch: {
	    'main.loaded.single': function mainLoadedSingle() {
	      var _this = this;
	
	      setTimeout(function () {
	        if (_this.main.single.acf.full_size_image) {
	          if (_this.main.single.acf.full_size_image.mime_type === 'image/gif') {
	            _this.mainImage = _this.main.single.acf.full_size_image.url;
	          } else {
	            _this.mainImage = _this.main.single.acf.full_size_image.sizes['pwr-large'];
	          }
	        }
	
	        _this.nextIndex = 0;
	        if (_this.main.horizontal.index < _this.collectionLength - 1) {
	          _this.nextIndex = parseInt(_this.main.horizontal.index) + 1;
	        }
	
	        _this.prevIndex = _this.collectionLength - 1;
	        if (_this.main.horizontal.index > 0) {
	          _this.prevIndex = _this.main.horizontal.index - 1;
	        }
	
	        var loader = (0, _preloader2.default)({
	          xhrImages: false
	        });
	        if (_this.main.horizontal.context[_this.prevIndex].acf.full_size_image) {
	          loader.add(_this.main.horizontal.context[_this.prevIndex].acf.full_size_image.sizes['pwr-large']);
	        }
	        if (_this.main.horizontal.context[_this.nextIndex].acf.full_size_image) {
	          loader.add(_this.main.horizontal.context[_this.nextIndex].acf.full_size_image.sizes['pwr-large']);
	        }
	        loader.load();
	      }, 50);
	      if (this.main.horizontal.context) {
	        for (var i = 0; i < this.main.horizontal.context.length; i++) {
	          if (this.main.horizontal.context[i].id === this.main.single.id) {
	            this.SET_N(i);
	          }
	        }
	      }
	      setTimeout(function () {
	        if (_this.main.single.acf && _this.main.single.acf.video) {
	          console.log('reframe');
	          (0, _noframe2.default)('iframe');
	        } else if (_this.main.single.acf && _this.main.single.acf.Image_display === 'Full screen') {
	          (0, _objectFitImages2.default)();
	        }
	      }, 200);
	    },
	    '$route': function $route() {
	      this.updateItem();
	    }
	  }
	};

/***/ }),

/***/ 194:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(31);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(30);
	
	var _interactjs = __webpack_require__(449);
	
	var _interactjs2 = _interopRequireDefault(_interactjs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'txt',
	  computed: (0, _extends3.default)({}, (0, _vuex.mapState)(['main'])),
	  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['HIDE_TEXT']), {
	    overlayClick: function overlayClick(e) {
	      if (e.target.attributes.id && e.target.attributes.id.value === 'overlay') {
	        var parent = document.querySelector('.active-item');
	        if (parent) {
	          parent.classList.remove('active-item');
	        }
	        document.body.classList.remove('no-scroll');
	        this.HIDE_TEXT();
	      }
	    },
	    closeClick: function closeClick() {
	      document.body.classList.remove('no-scroll');
	      this.HIDE_TEXT();
	    }
	  }),
	  mounted: function mounted() {
	    function dragMoveListener(event) {
	      var target = event.target;
	      console.dir(event.target);
	      var x = (parseFloat(target.getAttribute('data-x')) || 0) + event.dx;
	      var y = (parseFloat(target.getAttribute('data-y')) || 0) + event.dy;
	      target.style.webkitTransform = target.style.transform = 'translate(' + x + 'px, ' + y + 'px)';
	      target.setAttribute('data-x', x);
	      target.setAttribute('data-y', y);
	    }
	
	    if (!window.matchMedia('(max-device-width: 700px)').matches) {
	      (0, _interactjs2.default)('#textbox').draggable({ onmove: dragMoveListener });
	      (0, _interactjs2.default)('#textbox').allowFrom('.handle');
	    }
	  }
	};

/***/ }),

/***/ 442:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 443:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 444:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 445:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 446:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 447:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 448:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 464:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(448)
	
	var Component = __webpack_require__(35)(
	  /* script */
	  __webpack_require__(186),
	  /* template */
	  __webpack_require__(478),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 465:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(445)
	
	var Component = __webpack_require__(35)(
	  /* script */
	  __webpack_require__(188),
	  /* template */
	  __webpack_require__(474),
	  /* scopeId */
	  "data-v-59c217b0",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 466:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(35)(
	  /* script */
	  __webpack_require__(189),
	  /* template */
	  __webpack_require__(477),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 467:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(35)(
	  /* script */
	  __webpack_require__(190),
	  /* template */
	  __webpack_require__(470),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 468:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(444)
	
	var Component = __webpack_require__(35)(
	  /* script */
	  __webpack_require__(192),
	  /* template */
	  __webpack_require__(473),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 469:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(443)
	
	var Component = __webpack_require__(35)(
	  /* script */
	  __webpack_require__(193),
	  /* template */
	  __webpack_require__(472),
	  /* scopeId */
	  "data-v-3a35add2",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 470:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div')
	},staticRenderFns: []}

/***/ }),

/***/ 471:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return ((_vm.$route.name === "home" && _vm.mosaic && _vm.item.acf.show_in_front_page_mosaic) || _vm.$route.name === "search" || _vm.$route.name === "collection") ? _c('div', {
	    staticClass: "item",
	    attrs: {
	      "id": "item-" + _vm.item.id
	    }
	  }, [_c('v-waypoint', {
	    on: {
	      "waypoint-in": _vm.inHandler
	    }
	  }), _vm._v(" "), _c('div', {
	    class: _vm.imageClass
	  }, [(_vm.item.acf.mosaic_image.mime_type === "image/gif") ? [(_vm.item.acf.Image_display !== "None") ? _c('img', {
	    attrs: {
	      "src": _vm.item.acf.mosaic_image.url
	    },
	    on: {
	      "click": _vm.openSingle
	    }
	  }) : _c('img', {
	    staticClass: "no-link",
	    attrs: {
	      "src": _vm.item.acf.mosaic_image.url
	    }
	  })] : [(_vm.item.acf.link_image_to_collection && _vm.item.acf.mosaic_image.sizes && _vm.item.acf.mosaic_image.sizes["pwr-medium"]) ? _c('a', {
	    attrs: {
	      "href": _vm.item.acf.image_link
	    }
	  }, [_c('img', {
	    staticClass: "ksksks",
	    attrs: {
	      "src": _vm.item.acf.mosaic_image.sizes["pwr-medium"]
	    }
	  })]) : (_vm.item.acf.Image_display !== "None" && _vm.item.acf.mosaic_image.sizes && _vm.item.acf.mosaic_image.sizes["pwr-medium"]) ? _c('img', {
	    attrs: {
	      "src": _vm.item.acf.mosaic_image.sizes["pwr-medium"]
	    },
	    on: {
	      "click": _vm.openSingle
	    }
	  }) : (_vm.item.acf.mosaic_image.sizes && _vm.item.acf.mosaic_image.sizes["pwr-medium"]) ? _c('img', {
	    staticClass: "no-link",
	    attrs: {
	      "src": _vm.item.acf.mosaic_image.sizes["pwr-medium"]
	    }
	  }) : _vm._e()], _vm._v(" "), _c('figcaption', {
	    staticClass: "shown"
	  }, [_c('cap', {
	    attrs: {
	      "content": _vm.item.acf.caption,
	      "id": _vm.item.id,
	      "links": _vm.item.acf.links
	    }
	  })], 1)], 2)], 1) : _vm._e()
	},staticRenderFns: []}

/***/ }),

/***/ 472:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.main.loaded.single) ? _c('div', {
	    staticClass: "single-container"
	  }, [(!_vm.main.loaded.text) ? _c('div', {
	    attrs: {
	      "id": "exit"
	    },
	    on: {
	      "click": _vm.exit
	    }
	  }, [_c('span', [_vm._v("exit full-screen")])]) : _vm._e(), _vm._v(" "), (_vm.main.single.acf.audio) ? _c('div', {
	    attrs: {
	      "id": "audio-container"
	    }
	  }, [_c('audio', {
	    attrs: {
	      "src": _vm.main.single.acf.audio.url,
	      "controls": ""
	    }
	  })]) : _vm._e(), _vm._v(" "), (_vm.main.single.acf.video) ? _c('div', {
	    attrs: {
	      "id": "video-container"
	    }
	  }, [_c('iframe', {
	    attrs: {
	      "src": 'https://player.vimeo.com/video/' + _vm.main.single.acf.video + '?title=0&byline=0&portrait=0',
	      "width": "640",
	      "height": "360",
	      "frameborder": "0",
	      "webkitallowfullscreen": "",
	      "mozallowfullscreen": "",
	      "allowfullscreen": ""
	    }
	  })]) : (_vm.main.single.acf.Image_display === "Full screen" && _vm.mainImage.length > 0) ? _c('img', {
	    staticClass: "full",
	    attrs: {
	      "src": _vm.mainImage
	    }
	  }) : _c('img', {
	    staticClass: "fit",
	    attrs: {
	      "src": _vm.mainImage
	    }
	  }), _vm._v(" "), (_vm.main.horizontal.context && _vm.main.horizontal.context.length > 0) ? _c('div', [_c('div', {
	    staticClass: "nav prev",
	    on: {
	      "click": _vm.prevItem
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "nav next",
	    on: {
	      "click": _vm.nextItem
	    }
	  })]) : _vm._e()]) : _vm._e()
	},staticRenderFns: []}

/***/ }),

/***/ 473:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.main.loaded.search) ? _c('div', {
	    staticClass: "grid align-end"
	  }, [(!_vm.main.loaded.text) ? _c('div', {
	    attrs: {
	      "id": "exit"
	    },
	    on: {
	      "click": _vm.exit
	    }
	  }, [_c('span', [_vm._v("exit search")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.main.search), function(item, index) {
	    return _c('item', {
	      attrs: {
	        "index": index,
	        "item": item
	      }
	    })
	  })], 2) : _vm._e()
	},staticRenderFns: []}

/***/ }),

/***/ 474:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.main.loaded.collection) ? _c('div', {
	    staticClass: "grid align-end"
	  }, [(!_vm.main.loaded.text) ? _c('div', {
	    attrs: {
	      "id": "exit"
	    },
	    on: {
	      "click": _vm.exit
	    }
	  }, [_c('span', [_vm._v("exit collection")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.main.collection), function(item, index) {
	    return _c('item', {
	      attrs: {
	        "item": item
	      }
	    })
	  })], 2) : _vm._e()
	},staticRenderFns: []}

/***/ }),

/***/ 475:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "overlay"
	    },
	    on: {
	      "click": _vm.overlayClick
	    }
	  }, [_c('div', {
	    attrs: {
	      "id": "textbox"
	    }
	  }, [_c('div', {
	    staticClass: "handle top"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "handle bottom"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "handle left"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "handle right"
	  }), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "close-text"
	    },
	    on: {
	      "click": _vm.closeClick
	    }
	  }, [_vm._v("close")]), _vm._v(" "), (_vm.main.text.acf.pdf) ? _c('div', {
	    attrs: {
	      "id": "download"
	    }
	  }, [_vm._v("("), _c('a', {
	    attrs: {
	      "href": _vm.main.text.acf.pdf.url,
	      "target": "_blank"
	    }
	  }, [_vm._v("download/print")]), _vm._v(")")]) : _vm._e(), _vm._v(" "), _c('h1'), _vm._v(" "), _c('article', [_c('div', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.main.text.acf.text)
	    }
	  }), _vm._v(" "), _vm._l((_vm.main.text.acf.links), function(link) {
	    return _c('span', {
	      staticClass: "link-container"
	    }, [_c('span', [_vm._v("("), _c('a', {
	      attrs: {
	        "href": link.link,
	        "target": "_blank"
	      }
	    }, [_vm._v(_vm._s(link.title))]), _vm._v(")")])])
	  })], 2)])])
	},staticRenderFns: []}

/***/ }),

/***/ 476:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('span', {
	    staticClass: "caption-text",
	    domProps: {
	      "innerHTML": _vm._s(_vm.noSpaceContent)
	    }
	  }), _vm._v(" "), _vm._l((_vm.links), function(link) {
	    return _c('span', {
	      staticClass: "link-container"
	    }, [(link.link_type === "External") ? _c('span', [_vm._v("("), _c('a', {
	      attrs: {
	        "href": link.external_link,
	        "target": "_blank"
	      }
	    }, [_vm._v(_vm._s(link.link_title))]), _vm._v(")")]) : (link.link_type === "Text") ? _c('span', [_vm._v("("), _c('span', {
	      staticClass: "text-link",
	      attrs: {
	        "data-id": link.text_link.ID
	      }
	    }, [_vm._v(_vm._s(link.link_title))]), _vm._v(")")]) : _vm._e()])
	  })], 2)
	},staticRenderFns: []}

/***/ }),

/***/ 477:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "grid align-end"
	  }, _vm._l((_vm.main.items), function(item, index) {
	    return _c('item', {
	      attrs: {
	        "item": item,
	        "mosaic": "true"
	      }
	    })
	  }))
	},staticRenderFns: []}

/***/ }),

/***/ 478:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "app"
	    }
	  }, [_c('menu', [_c('header', {
	    class: {
	      "semi": _vm.$route.name === "index"
	    }
	  }, [_c('div', {
	    staticClass: "logo"
	  }, [_c('span', {
	    staticClass: "home-link",
	    attrs: {
	      "id": "logo"
	    },
	    on: {
	      "click": _vm.toHome
	    }
	  }, [_vm._v("Jacques Daniel")])]), _vm._v(" "), _c('div', {
	    staticClass: "about"
	  }, [(_vm.main.loaded.index && _vm.$route.name !== "index" && _vm.$route.name !== "single") ? _c('router-link', {
	    attrs: {
	      "to": "/index",
	      "id": "index"
	    }
	  }, [_vm._v("archive")]) : _vm._e()], 1), _vm._v(" "), (_vm.$route.name === "search" && _vm.main.search.length > 0) ? _c('div', {
	    attrs: {
	      "id": "search-marker"
	    }
	  }, [_vm._v("search results (" + _vm._s(_vm.main.search.length) + "): " + _vm._s(_vm.main.searchTerm))]) : (_vm.$route.name === "search" && _vm.main.search.length < 1) ? _c('div', [_vm._v("no results")]) : _vm._e()]), _vm._v(" "), (_vm.$route.name === "index" || _vm.$route.name === "single" || _vm.$route.name === "home") ? _c('div', {
	    class: {
	      "index": _vm.$route.name === "index"
	    },
	    attrs: {
	      "id": "text-container"
	    }
	  }, [_c('div', {
	    class: {
	      "inner": _vm.$route.name === "index"
	    }
	  }, [(_vm.main.loaded.single) ? _c('div', {
	    staticClass: "caption-container"
	  }, [(_vm.main.single.acf.extended_caption_check) ? _c('cap', {
	    attrs: {
	      "content": _vm.main.single.acf.extended_caption,
	      "links": _vm.main.single.acf.links
	    }
	  }) : _c('cap', {
	    attrs: {
	      "content": _vm.main.single.acf.caption,
	      "links": _vm.main.single.acf.links
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.main.loaded.index && _vm.$route.name === "index") ? _c('div', {
	    attrs: {
	      "id": "index-container"
	    }
	  }, [_c('div', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.main.index.acf.text)
	    }
	  })]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.$route.name === "home" || _vm.$route.name === "collection") ? _c('div', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.searchTerm),
	      expression: "searchTerm"
	    }],
	    attrs: {
	      "type": "text",
	      "placeholder": "search"
	    },
	    domProps: {
	      "value": (_vm.searchTerm)
	    },
	    on: {
	      "keyup": function($event) {
	        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.submitSearch($event)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.searchTerm = $event.target.value
	      }
	    }
	  })]) : _vm._e()]), _vm._v(" "), _c('router-view'), _vm._v(" "), (_vm.main.loaded.text) ? _c('txt') : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),

/***/ 482:
/***/ (function(module, exports) {

	/* (ignored) */

/***/ })

});


// WEBPACK FOOTER //
// static/js/app.38a3760c3a81e0886e01.js